import { Grid, Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import React from 'react';
import { colors } from 'theme/colors';

export const PhotoRequirements = () => {
  const { t } = useTranslations();

  const bullets = [
    'manageImages.requirements.fileFormat.text',
    'manageImages.requirements.colour.text',
    'manageImages.requirements.frame.text',
    'manageImages.requirements.resolution.text',
  ];

  return (
    <Grid
      size={{ xs: 12 }}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        rowGap: '4px',
        backgroundColor: colors.primary15,
        padding: '20px',
        borderRadius: '4px',
      }}
    >
      <Typography variant="subtitle2" sx={{ color: colors.primary500, fontSize: '14px' }}>
        {t('manageImages.requirements.header.label')}
      </Typography>
      <Typography variant="body2" sx={{ color: colors.primary500 }}>
        {t('manageImages.requirements.intro.text')}
      </Typography>
      <Typography variant="subtitle2" sx={{ color: colors.primary500, mt: '8px' }}>
        {t('manageImages.requirements.fileMust.label')}
      </Typography>
      <Typography
        variant="body2"
        component="ul"
        sx={{ color: colors.primary500, pl: '20px', m: 0, listStyleType: 'disc' }}
      >
        {bullets.map((it) => (
          <li key={it}>{t(it)}</li>
        ))}
      </Typography>
      <Typography variant="body2" sx={{ color: colors.primary500 }}>
        {t('manageImages.requirements.icao.text')}
      </Typography>
    </Grid>
  );
};
